import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Shield } from "lucide-react";

export default function BlogPage() {
  useEffect(() => {
    // Load Soro script dynamically
    const existing = document.querySelector('script[src*="trysoro.com"]');
    if (!existing) {
      const script = document.createElement("script");
      script.src = "https://app.trysoro.com/api/embed/9389bfa1-ec96-491d-90f2-4b118ce9d637";
      script.defer = true;
      document.body.appendChild(script);
    }
  }, []);

  return (
    <div data-testid="blog-page" className="min-h-screen bg-slate-50">
      {/* Header */}
      <div className="bg-white border-b border-slate-200/60">
        <div className="max-w-4xl mx-auto px-6 sm:px-8 py-6 flex items-center gap-4">
          <Link to="/" data-testid="blog-back-link" className="text-slate-500 hover:text-slate-900 transition-colors">
            <ArrowLeft className="w-5 h-5" />
          </Link>
          <div className="flex items-center gap-2">
            <div className="w-7 h-7 rounded-lg bg-emerald-500 flex items-center justify-center">
              <Shield className="w-3.5 h-3.5 text-white" />
            </div>
            <span className="font-semibold text-slate-900" style={{ fontFamily: 'Outfit, sans-serif' }}>CrediAcceso</span>
            <span className="text-slate-300 mx-1">/</span>
            <span className="text-slate-500 text-sm">Blog</span>
          </div>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-6 sm:px-8 py-12">
        <div id="soro-blog"></div>
      </div>
    </div>
  );
}
